<template>
    <div>
        {{appConstant.APP_VERSION_STATEMENT }} <span class="bold-font">{{appVersion}}</span>
    </div>
</template>

<script>
    import { appConstant } from "../../app.constant";

    export default {
        name: 'AppVersion',
        data() {
            return {
                appVersion: process.env.VUE_APP_VERSION,
                appConstant,
            };
        },
    };
</script>
